import React, { useState } from 'react'
import Form from './Form'
import List from './List'
import shortid from 'shortid'

const App = () => {
    const [todos, setTodos] = useState([

    ])



    // const item = () => {
    //     setIsDone(!isDone)
    // }


    const addTodo = content => {
        setTodos([
            ...todos,
            {
                content: content,
                id: shortid.generate(),
            }
        ])
    }
    const deleteTodo = id => {
        setTodos(todos.filter(todo => todo.id !== id))
    }


    return (
        <>
            <h1 style={{ textAlign: "center", backgroundColor: "#d2d200", borderRadius: "10px", position: "relative" }}>Todo App</h1>
            <Form addTodo={addTodo} />
            <List
                todos={todos}
                deleteTodo={deleteTodo}
            />
            <footer>
                <small style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    textAlign: "center",
                    color: "white",
                    backgroundColor: "black",
                    height: "50px",
                    lineHeight: "50px",
                    width: "100%"
                }}>© 2020</small>
            </footer>
        </>
    )
}

export default App